<template>
  <div>
    <InputLabel :value="title" margin-bottom="10" font-size="22">
      <div v-if="showErrorMessage" class="error-message">{{errorMessage}}</div>
    </InputLabel>
    <el-table
      class="fte-table"
      :data="computedData"
      empty-text="No Data Available"
      header-cell-class-name="table-header-dark">
      <el-table-column
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="row-label">{{scope.row.label}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Appropriated"
        header-align="center"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input-number
            v-if="isTotalRow(scope)"
            class="table-input total-display"
            :controls="false"
            :precision="2"
            size="small"
            disabled
            v-model="scope.row.appropriated"></el-input-number>
          <el-input-number
            v-else-if="!readonly && isPermColumn(scope)"
            class="table-input"
            :controls="false"
            :precision="2"
            size="small"
            v-model="allocation.fteAppropriatedPerm"
            @blur="handleAppropriatedPermBlur"></el-input-number>
          <el-input-number
            v-else-if="!readonly && isTempColumn(scope)"
            class="table-input"
            :controls="false"
            :precision="2"
            size="small"
            v-model="allocation.fteAppropriatedTemp"
            @blur="handleAppropriatedTempBlur"></el-input-number>
          <div v-else>{{ scope.row.appropriated | decimal }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="Unappropriated"
        header-align="center"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input-number
            v-if="isTotalRow(scope)"
            class="table-input total-display"
            :controls="false"
            :precision="2"
            size="small"
            disabled
            v-model="scope.row.unappropriated"></el-input-number>
          <el-input-number
            v-else-if="isTempColumn(scope) && !readonly"
            class="table-input"
            :controls="false"
            :precision="2"
            size="small"
            v-model="allocation.fteUnappropriatedTemp"
            @blur="handleUnappropriatedTempBlur"></el-input-number>
          <div v-else-if="isTempColumn(scope)">
            {{ scope.row.unappropriated | decimal }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import InputLabel from '../misc/InputLabel.vue';

export default {
  name: 'FteTable',
  components: {
    InputLabel,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    allocation: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    negative: {
      type: Boolean,
      default: false,
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedData() {
      return [{
        label: 'Perm',
        appropriated: this.allocation.fteAppropriatedPerm,
      }, {
        label: 'Temp',
        appropriated: this.allocation.fteAppropriatedTemp,
        unappropriated: this.allocation.fteUnappropriatedTemp,
      }, {
        label: 'TOTAL',
        appropriated: this.allocation.fteAppropriatedPerm + this.allocation.fteAppropriatedTemp,
        unappropriated: this.allocation.fteUnappropriatedTemp,
      }];
    },
    errorMessage() {
      const sign = this.negative ? 'positive' : 'negative';
      return `Values cannot be ${sign}.`;
    },
  },
  data() {
    return {
      showErrorMessage: false,
    };
  },
  methods: {
    isTotalRow(scope) {
      return scope.$index === 2;
    },
    isPermColumn(scope) {
      return scope.row.label === 'Perm';
    },
    isTempColumn(scope) {
      return scope.row.label === 'Temp';
    },
    handleAppropriatedPermBlur(event) {
      if (!event.target.value) {
        this.allocation.fteAppropriatedPerm = 0.00;
      } else if ((this.negative && event.target.value > 0)
                  || (!this.negative && event.target.value < 0)) {
        this.allocation.fteAppropriatedPerm = 0.00;
        this.showError();
      }
    },
    handleAppropriatedTempBlur(event) {
      if (!event.target.value) {
        this.allocation.fteAppropriatedTemp = 0.00;
      } else if ((this.negative && event.target.value > 0)
        || (!this.negative && event.target.value < 0)) {
        this.allocation.fteAppropriatedTemp = 0.00;
        this.showError();
      }
    },
    handleUnappropriatedTempBlur(event) {
      if (!event.target.value) {
        this.allocation.fteUnappropriatedTemp = 0.00;
      } else if ((this.negative && event.target.value > 0)
        || (!this.negative && event.target.value < 0)) {
        this.allocation.fteUnappropriatedTemp = 0.00;
        this.showError();
      }
    },
    showError() {
      this.showErrorMessage = true;
      setTimeout(() => {
        this.showErrorMessage = false;
      }, 3500);
    },
  },
};
</script>

<style scoped lang="scss">
  .info-icon {
    margin-left: 5px;
    font-size: 16px;
  }
  .error-message {
    display: inline-flex;
    font-size: 13px;
    font-style: italic;
    margin-left: 13px;
    color: #EB5757;
  }

  .fte-table {
    /deep/ .el-table__row {
      background: rgba(238, 245, 247, 0.5);
    }
    .row-label {
      font-weight: bold;
    }
    .table-input {
      width: 100%;
      display: block;

      &.total-display {
        /deep/ .el-input__inner {
          background: #748C9C;
          color: white;
          font-weight: bold;
          pointer-events: none;
        }
      }
    }
  }
</style>
